export const ROUTER_UTILS = {
  config: {
    base: {
      home: ''
    },
    errorResponse: {
      notFound: '404',
    },
  },
};
